"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useClient_1 = __importDefault(require("./useClient"));
function useRefetchQueries(options = {}) {
    const client = useClient_1.default(options.clientName);
    return async (names) => {
        names = Array.isArray(names) ? names : [names];
        const refetchQueryPromises = [];
        // @ts-ignore //TODO: Remove access to private variable
        client.queryManager.queries.forEach(({ observableQuery }) => {
            if (observableQuery && names.includes(observableQuery.queryName)) {
                refetchQueryPromises.push(observableQuery.refetch());
            }
        });
        const results = await Promise.all(refetchQueryPromises);
        return Array.isArray(names) ? results : results[0];
    };
}
exports.default = useRefetchQueries;
